(() => {
  const init = (root) => {
    if (!root || root.dataset.scsInitialized === 'true') return;
    root.dataset.scsInitialized = 'true';

    const isEn = root.dataset.locale === 'en';
    const locale = isEn ? 'en-CA' : 'fr-CA';
    const currency = root.dataset.currency || 'CAD';
    const formatMoney = (cents) => new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(Number(cents || 0) / 100);
    const value = (key) => Number(root.dataset[key] || 0);
    const available = (key) => root.dataset[key] === 'true';
    const quantityLabel = root.querySelector('[data-scs-quantity]');
    const totalLabel = root.querySelector('[data-scs-total]');
    const mobileTotal = root.querySelector('[data-scs-mobile-total]');
    const optionsTotalLabel = root.querySelector('[data-scs-options-total]');
    const breakdown = root.querySelector('[data-scs-breakdown]');
    const status = root.querySelector('[data-scs-status]');
    const addButton = root.querySelector('[data-scs-add]');
    const installationSelect = root.querySelector('[data-scs-installation-select]');
    const optionsPanel = root.querySelector('[data-scs-options]') || root;
    let quantity = 1;

    const strings = isEn ? {
      machine: 'Inspire SCS station',
      fid7: 'Inspire FID7 Pro bench',
      scs: 'Inspire SCS bench',
      legs: 'Inspire leg extension/curl attachment',
      preacher: 'Inspire preacher curl attachment',
      weights: 'Inspire 50 lb add-on weights (pair)',
      storage: 'Inspire bench accessory storage base',
      delivery: 'Delivery preference',
      installation: 'Installation preference',
      deliver: 'Delivery included in Quebec',
      within: 'Installation within 200 km',
      beyond: 'Installation beyond 200 km — call to confirm',
      stock: 'One or more selected items are currently unavailable. Please update your configuration.',
      error: 'The configuration could not be added to the cart. Please try again.',
      pricing: 'The selected configuration price is temporarily unavailable. Please contact us before ordering.',
      options: 'Selected options',
      baseOnly: 'Station only',
      andOptions: 'with selected attachments',
      bench: 'Training bench',
    } : {
      machine: 'Station Inspire SCS',
      fid7: 'Banc Inspire FID7 Pro',
      scs: 'Banc Inspire SCS',
      legs: 'Extension / Curl des jambes Inspire',
      preacher: 'Accessoire pour pupitre à biceps Inspire',
      weights: 'Poids supplémentaires Inspire de 50 lb (paire)',
      storage: 'Support pour accessoires de banc Inspire',
      delivery: 'Préférence de livraison',
      installation: 'Préférence d’installation',
      deliver: 'Livraison incluse au Québec',
      within: 'Installation à moins de 200 km',
      beyond: 'Installation au-delà de 200 km — appeler pour confirmer',
      stock: 'Un ou plusieurs articles sélectionnés ne sont pas disponibles. Veuillez modifier votre configuration.',
      error: 'Impossible d’ajouter la configuration au panier. Veuillez réessayer.',
      pricing: 'Le prix de cette configuration est temporairement indisponible. Veuillez nous contacter avant de commander.',
      options: 'Options sélectionnées',
      baseOnly: 'Station seulement',
      andOptions: 'avec les accessoires sélectionnés',
      bench: 'Banc d’entraînement',
    };

    const getSelection = () => {
      const bench = optionsPanel.querySelector('[data-scs-bench]:checked');
      return {
        bench: bench ? bench.value : null,
        legs: Boolean(optionsPanel.querySelector('[data-scs-addon="legs"]:checked')),
        preacher: Boolean(optionsPanel.querySelector('[data-scs-addon="preacher"]:checked')),
        weights: Boolean(optionsPanel.querySelector('[data-scs-addon="weights"]:checked')),
        storage: Boolean(optionsPanel.querySelector('[data-scs-addon="storage"]:checked')),
      };
    };
    const bundleMask = (selection) => (selection.legs ? 1 : 0)
      + (selection.preacher ? 2 : 0)
      + (selection.weights ? 4 : 0);
    const bundleFor = (selection) => {
      const mask = bundleMask(selection);
      if (!mask) return {
        id: value('baseId'),
        price: value('basePrice'),
        available: available('baseAvailable'),
        inventory: value('baseInventoryQuantity'),
      };
      return {
        id: value(`bundle${mask}Id`),
        price: value(`bundle${mask}Price`),
        available: available(`bundle${mask}Available`),
        inventory: value(`bundle${mask}InventoryQuantity`),
        key: `bundle${mask}`,
      };
    };
    const getLines = (selection) => {
      const lines = [{ label: strings.machine, cents: value('basePrice') }];
      if (selection.bench) {
        lines.push({
          label: strings[selection.bench],
          cents: value(selection.bench === 'fid7' ? 'benchFid7Price' : 'benchScsPrice'),
        });
      }
      ['legs', 'preacher', 'weights', 'storage'].forEach((key) => {
        if (selection[key]) lines.push({ label: strings[key], cents: value(`${key}Price`) });
      });
      return lines;
    };
    const priceMatches = (selection, bundle) => getLines(selection)
      .reduce((sum, line) => sum + line.cents, 0) === getTotal(selection, bundle);
    const getTotal = (selection, bundle) => (
      bundle.price
      + (selection.bench ? value(selection.bench === 'fid7' ? 'benchFid7Price' : 'benchScsPrice') : 0)
      + (selection.storage ? value('storagePrice') : 0)
    );
    const inventoryLineAvailable = (key, amount) => {
      const management = root.dataset[`${key}InventoryManagement`];
      const policy = root.dataset[`${key}InventoryPolicy`];
      return !management || policy !== 'deny' || value(`${key}InventoryQuantity`) >= amount;
    };
    const validInventory = (selection, bundle) => {
      if (!bundle.id || !bundle.available || (bundle.key && !inventoryLineAvailable(bundle.key, quantity))) return false;
      if (!available('baseAvailable') || !inventoryLineAvailable('base', quantity)) return false;
      const lines = [
        !selection.bench || (
          available(selection.bench === 'fid7' ? 'benchFid7Available' : 'benchScsAvailable')
          && inventoryLineAvailable(selection.bench === 'fid7' ? 'benchFid7' : 'benchScs', quantity)
        ),
        !selection.legs || (available('legsAvailable') && inventoryLineAvailable('legs', quantity)),
        !selection.preacher || (available('preacherAvailable') && inventoryLineAvailable('preacher', quantity)),
        !selection.weights || (available('weightsAvailable') && inventoryLineAvailable('weights', quantity * 2)),
        !selection.storage || (available('storageAvailable') && inventoryLineAvailable('storage', quantity)),
      ];
      return lines.every(Boolean);
    };

    const updateTotals = () => {
      const selection = getSelection();
      const bundle = bundleFor(selection);
      const total = getTotal(selection, bundle) * quantity;
      const hasChoices = Boolean(selection.bench || selection.legs || selection.preacher || selection.weights || selection.storage);
      if (totalLabel) totalLabel.textContent = formatMoney(total);
      if (optionsTotalLabel) optionsTotalLabel.textContent = formatMoney(total);
      if (mobileTotal) mobileTotal.hidden = !hasChoices;
      if (quantityLabel) quantityLabel.textContent = String(quantity);

      if (breakdown) {
        breakdown.replaceChildren();
        getLines(selection).forEach((line) => {
          const item = document.createElement('li');
          item.textContent = `${line.label} — ${formatMoney(line.cents * quantity)}`;
          breakdown.appendChild(item);
        });
      }
      optionsPanel.querySelectorAll('[data-scs-bench-card]').forEach((card) => {
        const input = card.querySelector('[data-scs-bench]');
        card.classList.toggle('is-selected', Boolean(input && input.checked));
      });
      const totalIsValid = bundle.id && bundle.price > 0 && total >= bundle.price
        && priceMatches(selection, bundle);
      if (status) status.textContent = !totalIsValid ? strings.pricing : (!validInventory(selection, bundle) ? strings.stock : '');
      if (addButton) addButton.disabled = !totalIsValid || !validInventory(selection, bundle);
    };

    root.querySelectorAll('[data-scs-bench]').forEach((input) => input.addEventListener('change', updateTotals));
    root.querySelector('[data-scs-clear-bench]')?.addEventListener('click', () => {
      optionsPanel.querySelectorAll('[data-scs-bench]').forEach((input) => { input.checked = false; });
      updateTotals();
    });
    root.querySelectorAll('[data-scs-addon]').forEach((input) => input.addEventListener('change', updateTotals));
    root.querySelector('[data-scs-minus]')?.addEventListener('click', () => {
      quantity = Math.max(1, quantity - 1);
      updateTotals();
    });
    root.querySelector('[data-scs-plus]')?.addEventListener('click', () => {
      quantity = Math.min(99, quantity + 1);
      updateTotals();
    });

    const installationNote = root.querySelector('[data-scs-installation-case]');
    const updateInstallation = () => {
      if (installationNote) installationNote.hidden = installationSelect?.value !== 'case';
    };
    installationSelect?.addEventListener('change', updateInstallation);
    updateInstallation();

    const dialog = root.querySelector('[data-scs-dialog]');
    const dialogContent = root.querySelector('[data-scs-dialog-content]');
    let dialogCopy = {};
    try {
      dialogCopy = JSON.parse(root.querySelector('[data-scs-dialog-copy]')?.textContent || '{}')[isEn ? 'en' : 'fr'] || {};
    } catch (error) {
      console.error('SCS configurator dialog translations could not be read.', error);
    }
    const guidePrice = (guide) => {
      if (guide === 'fid7') return value('benchFid7Price');
      if (guide === 'scs') return value('benchScsPrice');
      if (guide === 'legs') return value('legsPrice');
      if (guide === 'preacher') return value('preacherPrice');
      if (guide === 'weights') return value('weightsPrice');
      if (guide === 'storage') return value('storagePrice');
      return 0;
    };
    const openDialog = (guide, sourceButton) => {
      const copy = dialogCopy.guides?.[guide];
      if (!dialog || !dialogContent || !copy) return;
      dialogContent.replaceChildren();
      const heading = document.createElement('h2');
      heading.id = `${root.id}-dialog-title`;
      heading.textContent = copy.title;
      const header = document.createElement('div');
      header.className = 'gd-scs__dialog-header';
      const sourceImage = sourceButton
        ?.closest('.gd-scs__bench-card, .gd-scs__addon-row')?.querySelector('img');
      if (sourceImage) {
        const image = document.createElement('img');
        image.className = 'gd-scs__dialog-image';
        image.src = sourceImage.src.replace(/([?&]width=)\d+/, (_match, prefix) => `${prefix}360`);
        image.alt = copy.title;
        image.width = 144;
        image.height = 128;
        header.appendChild(image);
      }
      header.appendChild(heading);
      const price = document.createElement('p');
      price.className = 'gd-scs__dialog-price';
      price.textContent = `${dialogCopy.price}: ${formatMoney(guidePrice(guide))}`;
      const intro = document.createElement('p');
      intro.textContent = copy.intro;
      const addsHeading = document.createElement('h3');
      addsHeading.textContent = dialogCopy.adds;
      const addsList = document.createElement('ul');
      (copy.adds || []).forEach((text) => {
        const item = document.createElement('li');
        item.textContent = text;
        addsList.appendChild(item);
      });
      const chooseHeading = document.createElement('h3');
      chooseHeading.textContent = dialogCopy.choose;
      const choose = document.createElement('p');
      choose.textContent = copy.choose;
      const compatibilityHeading = document.createElement('h3');
      compatibilityHeading.textContent = dialogCopy.compatibility;
      const compatibility = document.createElement('p');
      compatibility.textContent = copy.compatibility;
      dialogContent.append(header, price, intro, addsHeading, addsList, chooseHeading, choose, compatibilityHeading, compatibility);
      if (copy.url) {
        const link = document.createElement('a');
        link.href = copy.url;
        link.textContent = copy.linkLabel;
        dialogContent.appendChild(link);
      }
      if (!dialog.open) dialog.showModal();
    };
    root.querySelectorAll('[data-scs-guide]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openDialog(button.dataset.scsGuide, button);
      });
    });
    root.querySelector('[data-scs-close]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    const appendInput = (form, name, inputValue) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = String(inputValue);
      form.appendChild(input);
    };
    const submitConfiguration = () => {
      const selection = getSelection();
      const bundle = bundleFor(selection);
      if (!bundle.id || !bundle.price || !bundle.available || !priceMatches(selection, bundle)) {
        if (status) status.textContent = strings.pricing;
        return;
      }
      if (!validInventory(selection, bundle)) {
        if (status) status.textContent = strings.stock;
        return;
      }
      if (addButton) addButton.disabled = true;
      const form = document.createElement('form');
      form.method = 'post';
      form.action = root.dataset.cartUrl || `${window.Shopify?.routes?.root || '/'}cart/add`;
      form.acceptCharset = 'UTF-8';
      form.style.display = 'none';
      let lineIndex = 0;
      const names = ['legs', 'preacher', 'weights']
        .filter((key) => selection[key]).map((key) => strings[key]);
      const configuration = [
        selection.bench ? strings[selection.bench] : '',
        ...names,
        selection.storage ? strings.storage : '',
      ].filter(Boolean).join(', ') || strings.baseOnly;
      const addLine = (variantId, lineQuantity, properties = {}) => {
        if (!variantId || lineQuantity < 1) return;
        appendInput(form, `items[${lineIndex}][id]`, variantId);
        appendInput(form, `items[${lineIndex}][quantity]`, lineQuantity);
        Object.entries(properties).forEach(([key, property]) => appendInput(form, `items[${lineIndex}][properties][${key}]`, property));
        lineIndex += 1;
      };
      const baseProperties = {
        [strings.delivery]: strings.deliver,
        [strings.installation]: installationSelect?.value === 'case' ? strings.beyond : strings.within,
        [strings.options]: configuration,
      };
      addLine(bundle.id, quantity, baseProperties);
      const linkedProperties = { [strings.options]: configuration };
      if (selection.bench === 'fid7') addLine(value('benchFid7Id'), quantity, linkedProperties);
      if (selection.bench === 'scs') addLine(value('benchScsId'), quantity, linkedProperties);
      if (selection.storage) addLine(value('storageId'), quantity, linkedProperties);
      if (!lineIndex) {
        if (status) status.textContent = strings.error;
        if (addButton) addButton.disabled = false;
        return;
      }
      appendInput(form, 'return_to', root.dataset.cartReturn || `${window.Shopify?.routes?.root || '/'}cart`);
      document.body.appendChild(form);
      form.submit();
    };
    addButton?.addEventListener('click', submitConfiguration);

    const galleryColumn = root.closest('[data-product-wrapper]')?.querySelector('[data-scs-gallery-column]');
    if (galleryColumn && optionsPanel !== root) {
      optionsPanel.classList.add('gd-scs');
      galleryColumn.appendChild(optionsPanel);
    }
    updateTotals();
  };

  const start = () => document.querySelectorAll('[data-scs-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => {
    event.target?.querySelectorAll?.('[data-scs-root]').forEach(init);
    if (event.target?.matches?.('[data-scs-root]')) init(event.target);
  });
})();